import { forwardRef, type SVGProps } from 'react';

export const View = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="m10.387 8c0 1.32-1.0666 2.3866-2.3866 2.3866s-2.3867-1.0666-2.3867-2.3866 1.0667-2.3867 2.3867-2.3867 2.3866 1.0667 2.3866 2.3867z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m7.9999 13.513c2.3533 0 4.5467-1.3867 6.0733-3.7866 0.6-0.94 0.6-2.52 0-3.46-1.5266-2.4-3.72-3.7867-6.0733-3.7867-2.3533 0-4.5467 1.3867-6.0733 3.7867-0.6 0.94-0.6 2.52 0 3.46 1.5267 2.4 3.72 3.7866 6.0733 3.7866z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
